import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { LoginPage } from './pages/LoginPage';
import { TwoFactorPage } from './pages/TwoFactorPage';
import { TwoFactorSetupPage } from './pages/TwoFactorSetupPage';
import { ChangePasswordPage } from './pages/ChangePasswordPage';
import { DashboardPage } from './pages/DashboardPage';
import { AdminPage } from './pages/AdminPage';
import { MonitoringPage } from './pages/MonitoringPage';
import { ImpressumPage } from './pages/ImpressumPage';
import { UserManagementPage } from './pages/UserManagementPage';
import { RoleManagementPage } from './pages/RoleManagementPage';
import { ChatPage } from './pages/ChatPage';
import { AccountsPage } from './pages/AccountsPage';
import { GroupsPage } from './pages/GroupsPage';
import { WebsiteAnalyticsPage } from './pages/WebsiteAnalyticsPage';
import { AusweisAdminPage } from './pages/AusweisAdminPage';
import { ToolsPage } from './pages/ToolsPage';
import { Layout } from './components/Layout';

function Loading() {
  return <div className="min-h-screen flex items-center justify-center text-slate-500">Laden ...</div>;
}

function Protected({ children }: { children: JSX.Element }) {
  const { me, loading, mfaVerified } = useAuth();
  if (loading) return <Loading />;
  if (!me) return <Navigate to="/login" replace />;
  if (me.totpEnabled && !mfaVerified) return <Navigate to="/2fa" replace />;
  if (!me.totpEnabled) return <Navigate to="/2fa-setup" replace />;
  if (me.mustChangePassword) return <Navigate to="/passwort-aendern" replace />;
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/2fa" element={<TwoFactorPage />} />
      <Route path="/2fa-setup" element={<TwoFactorSetupPage />} />
      <Route path="/passwort-aendern" element={<ChangePasswordPage />} />
      <Route path="/" element={<Protected><DashboardPage /></Protected>} />
      <Route path="/admin" element={<Protected><AdminPage /></Protected>} />
      <Route path="/users" element={<Protected><UserManagementPage /></Protected>} />
      <Route path="/roles" element={<Protected><RoleManagementPage /></Protected>} />
      <Route path="/chat" element={<Protected><ChatPage /></Protected>} />
      <Route path="/accounts" element={<Protected><AccountsPage /></Protected>} />
      <Route path="/groups" element={<Protected><GroupsPage /></Protected>} />
      <Route path="/ausweis" element={<Protected><AusweisAdminPage /></Protected>} />
      <Route path="/tools" element={<Protected><ToolsPage /></Protected>} />
      <Route path="/website" element={<Protected><WebsiteAnalyticsPage /></Protected>} />
      <Route path="/monitoring" element={<Protected><MonitoringPage /></Protected>} />
      <Route path="/impressum" element={<Protected><ImpressumPage /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
